/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type VerifyGcpKmsKeySecurity = {
  sessionHeaderGramSession?: string | undefined;
};

export type VerifyGcpKmsKeyRequest = {
  /**
   * The ID of the key to verify.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
};

/** @internal */
export type VerifyGcpKmsKeySecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
};

/** @internal */
export const VerifyGcpKmsKeySecurity$outboundSchema: z.ZodMiniType<
  VerifyGcpKmsKeySecurity$Outbound,
  VerifyGcpKmsKeySecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function verifyGcpKmsKeySecurityToJSON(
  verifyGcpKmsKeySecurity: VerifyGcpKmsKeySecurity,
): string {
  return JSON.stringify(
    VerifyGcpKmsKeySecurity$outboundSchema.parse(verifyGcpKmsKeySecurity),
  );
}

/** @internal */
export type VerifyGcpKmsKeyRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
};

/** @internal */
export const VerifyGcpKmsKeyRequest$outboundSchema: z.ZodMiniType<
  VerifyGcpKmsKeyRequest$Outbound,
  VerifyGcpKmsKeyRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
    });
  }),
);

export function verifyGcpKmsKeyRequestToJSON(
  verifyGcpKmsKeyRequest: VerifyGcpKmsKeyRequest,
): string {
  return JSON.stringify(
    VerifyGcpKmsKeyRequest$outboundSchema.parse(verifyGcpKmsKeyRequest),
  );
}
